//------------------------------------------------------------------------
// Make iframes responsive, preserving their aspect ratio (like FitVid.js)
//------------------------------------------------------------------------
"use strict";

import FluidIframe from "@threespot/fluid-iframe";

const iframes = document.querySelectorAll(".u-richtext > iframe");
const youtubeBlocks = document.querySelectorAll(
  ".wp-block-embed.is-type-video iframe"
);

youtubeBlocks.forEach((el) => new FluidIframe(el));
iframes.forEach((el) => new FluidIframe(el));



// WEBPACK FOOTER //
// ./scripts/modules/fluid-iframes.js